import { useTranslation } from 'react-i18next'
import { ResetPasswordForm } from '@/components/features/auth'

export function ResetPasswordPage() {
  const { t } = useTranslation('auth')

  return (
    <div className="w-full max-w-md">
      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold">{t('resetPasswordTitle')}</h1>
        <p className="text-muted-foreground">{t('resetPasswordSubtitle')}</p>
      </div>
      <ResetPasswordForm />
    </div>
  )
}
